<template>
  <div class="form-group">
    <label class="control-label col-md-3 col-sm-3 col-xs-12">{{ title }}</label>
    <div class="col-md-9 col-sm-9 col-xs-12">
      <div class="input-group mb-2">
        <input
          :type="!show ? 'password' : 'text'"
          class="form-control"
          :class="{ 'is-invalid': error }"
          :name="name"
          v-model="inputValue"
        />

        <div class="input-group-append btn-cursor">
          <div class="input-group-text" @click="show = !show">
            <i class="fa" :class="{ 'fa-eye-slash': !show, 'fa-eye': show }" aria-hidden="true"></i>
          </div>
        </div>
      </div>

      <span class="btn-generate" @click="generate">
        <small>Generovat</small>
      </span>

      <div v-if="error" class="invalid-feedback">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    error: String,
    value: String,
    name: String,
    title: String
  },
  data() {
    return {
      show: false,
      inputValue: this.value
    }
  },
  methods: {
    rand(length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length

      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }

      return result
    },
    generate() {
      this.inputValue = this.rand(16)
    }
  }
}
</script>

<style lang="stylus">
  .btn-cursor
    cursor pointer
  .btn-generate
    float right
    position relative
    top -10px
    cursor pointer
    &:hover
      color: #4e73df
</style>
